const noop = val => val;

export function createSetPropMutation(prop, defaultValue = null) {
  return (state, value) => {
    state[prop] = value || defaultValue;
  };
}

export function createClearPropMutation(prop, value = null) {
  return state => {
    state[prop] = value;
  };
}

export function createGetPropGetter(prop, defaultValue = null) {
  return state => state[prop] || defaultValue;
}

export function mapGetPropGetters(props = []) {
  const map = {};

  if (Array.isArray(props)) {
    props.forEach(prop => {
      map[prop] = createGetPropGetter(prop);
    });
  }

  return map;
}

export function createRunMutationAction(mutation) {
  return ({ commit }, value) => {
    commit(mutation, value);
  };
}

export function isPrefixOfDomain(prefix, domains) {
  // eslint-disable-next-line consistent-return
  domains.forEach(domain => {
    if (prefix.endsWith(`.${domain}`)) {
      return true;
    }
  });
  return false;
}

export function createLoadingAction({
  method,
  dataKey,
  settingDataMutation,
  settingErrorMutation,
  settingLoadingMutation,
  payloadExtractor = noop,
  settingDefaultDataMutation = null,
}) {
  return async ({ commit }, options) => {
    commit(settingLoadingMutation, { [dataKey]: true });

    try {
      const data = await method(payloadExtractor(options));
      commit(settingDataMutation, data);
      commit(settingErrorMutation, { [dataKey]: null });
      return data;
    } catch (err) {
      commit(settingErrorMutation, { [dataKey]: err });
      if (settingDefaultDataMutation) {
        commit(settingDefaultDataMutation, []);
      }
      throw err;
    } finally {
      commit(settingLoadingMutation, { [dataKey]: false });
    }
  };
}
